import { projectCatalogCategories } from '@/Models';
import Config from '@/Config.js';

export function buildExploreUrlParams(searchParams) {
    const params = removeIncludeRefsProp(searchParams); // TODO: Remove in #20854

    const query = new URLSearchParams();
    Object.entries(params)
        .filter(([, value]) => value !== null && value !== undefined)
        .forEach(([key, value]) => query.set(key, value));

    return `${Config.navigation.searchUrl}/?${query}`;
}

export function buildProjectExplorer(label, key, searchParams, actionLabel) {
    const params = removeIncludeRefsProp(searchParams); // TODO: Remove in #20854

    searchParams.excludeDemotedProjects = true;
    return {
        label,
        key,
        searchParams,
        actionLabel,
        url: buildExploreUrlParams(params),
    };
}

export function buildProjectExplorerModel(label, key, searchParams, actionLabel) {
    return [buildProjectExplorer(label, key, searchParams, actionLabel)];
}

export function getHomeProjectListCategoryKeys(categoryID) {
    return Object.keys(projectCatalogCategories).find(key => projectCatalogCategories[key] === categoryID);
}

function removeIncludeRefsProp(searchParams) {
    const params = { ...searchParams };
    delete params.includeRefs;
    return params;
}
